<script>
import TwButton from '@/components/generic/tw-button.vue'

export default {
  name: 'FundraiserTeamAboutTab',
  components: { TwButton },
  props: {
    fundraiser: {
      type: Object,
      required: true
    },
    team: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      Expanded: false
    }
  },
  computed: {
    isClamped() {
      const elm = this.$refs.paragraph
      return elm => elm.scrollHeight > elm.clientHeight
    },
    fundraiserTeamAboutContent() {
      if(this.team.description) {
        return this.team.description
      }
      return this.fundraiser.long_description
    }
  }
}
</script>

<template>
  <div>
    <div :id="'about-container-' + fundraiser.id" ref="paragraph" :class="['fundraiser-description-container', {'line-clamp-4':!Expanded}]" v-html="fundraiserTeamAboutContent" />
    <tw-button v-if="isClamped" class="underline mt-3" variant="link" @click="Expanded = !Expanded">
      {{ Expanded ? 'Read less' : 'Read more' }}
    </tw-button>
    <p v-if="fundraiser.settings && fundraiser.settings.disclaimer" class="my-8" v-html="fundraiser.settings.disclaimer" />
  </div>
</template>

<style scoped>

</style>
